import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import urlJoin from 'proper-url-join';
import { map } from 'rxjs/operators';

class WebCoreService {
    constructor() { }
}
WebCoreService.ɵprov = i0.ɵɵdefineInjectable({ factory: function WebCoreService_Factory() { return new WebCoreService(); }, token: WebCoreService, providedIn: "root" });
WebCoreService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
WebCoreService.ctorParameters = () => [];

class WebCoreComponent {
}
WebCoreComponent.decorators = [
    { type: Component, args: [{
                selector: 'lbmx-web-core',
                template: ` <p>web-core works!</p> `
            },] }
];

class WebCoreModule {
}
WebCoreModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    WebCoreComponent
                ],
                imports: [],
                exports: [
                    WebCoreComponent
                ]
            },] }
];

var HttpMethod;
(function (HttpMethod) {
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
})(HttpMethod || (HttpMethod = {}));
class BaseHttpService {
    constructor(http) {
        this.http = http;
        this._baseUrl = '';
    }
    set baseUrl(baseUrl) {
        this._baseUrl = baseUrl;
    }
    get baseUrl() {
        return this._baseUrl;
    }
    fetchWithFqn({ endpoint, httpMethod, body, responseField, }) {
        return this.buildRequest(endpoint, httpMethod, body).pipe(map((response) => responseField && response ? response[responseField] : response));
    }
    fetch({ endpoint, httpMethod, body, responseField, options, }) {
        return this.buildRequest(urlJoin(this._baseUrl, endpoint), httpMethod, body, options).pipe(map((response) => responseField && response ? response[responseField] : response));
    }
    buildRequest(endpoint, httpMethod, body, options) {
        switch (httpMethod) {
            case HttpMethod.POST:
                return this.http.post(endpoint, body, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.PUT:
                return this.http.put(endpoint, body, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.DELETE:
                return this.http.delete(endpoint, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.GET:
            default:
                return this.http.get(endpoint, Object.assign(Object.assign({}, options), { withCredentials: true }));
        }
    }
}
BaseHttpService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BaseHttpService_Factory() { return new BaseHttpService(i0.ɵɵinject(i1.HttpClient)); }, token: BaseHttpService, providedIn: "root" });
BaseHttpService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
BaseHttpService.ctorParameters = () => [
    { type: HttpClient }
];

/*
 * Public API Surface of web-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BaseHttpService, HttpMethod, WebCoreComponent, WebCoreModule, WebCoreService };
//# sourceMappingURL=lbmx-web-core.js.map
